import { atom } from 'recoil'

export const restaurantListState = atom<null | any[]>({
  key: 'restaurantListAtom',
  default: [],
})
